export default __webpack_public_path__ + "static/hindu-233ae8b64ca1ee19fa0f85552c2eb959.png";